import React from 'react';
import { createRoot } from 'react-dom/client';
import RteEditor from './react/RteEditor';

document.querySelectorAll('.js-input-rte').forEach(($element) => {
  try {
    const isDisabled = $element.hasAttribute('disabled');
    const isError = $element.getAttribute('aria-invalid') === 'true';
    const $wrapper = document.createElement('div');
    $wrapper.classList.add('input__rte-wrapper');
    $element.parentNode.insertBefore($wrapper, $element);
    $wrapper.appendChild($element);
    const $eWrapper = document.createElement('div');
    $eWrapper.classList.add('input__rte-editor-wrapper');
    if (isDisabled) {
      $eWrapper.classList.add('input__rte-editor-wrapper--disabled');
    }
    if (isError) {
      $eWrapper.classList.add('input__rte-editor-wrapper--error');
    }
    $wrapper.appendChild($eWrapper);
    $eWrapper.setAttribute('role', 'application');
    const elementId = $element.id || 'rte-input';
    const rteId = `${elementId}-rte`;
    const $label = document.querySelector(`label[for="${elementId}"]`);
    const labelContent = $label ? $label?.textContent : null;
    $label?.removeAttribute('for');
    $eWrapper.setAttribute('aria-label', `${labelContent} - Rich Text Editor`);
    $eWrapper.setAttribute('id', rteId);
    const root = createRoot($eWrapper);

    const handleChange = (htmlContent) => {
      // eslint-disable-next-line no-param-reassign
      $element.value = htmlContent;
    };

    root.render(
      <RteEditor
        onChange={handleChange}
        id={rteId}
        inputId={elementId}
        targetElement={$element}
        isDisabled={isDisabled}
        isError={isError}
        initialValue={`<p>${$element.value}</p>`}
      />,
    );

    $element.setAttribute('aria-hidden', 'true');
    $element.setAttribute('type', 'hidden');
    $element.setAttribute('style', 'display: none;');
    $element.setAttribute('tabindex', '-1');
  } catch (error) {
    console.error('Error rendering RteEditor:', error);
  }
});
